(function (appComponents) {

	appComponents.services.emailNotification = function (Components) {

		var emailNotification = {};

		emailNotification.name = "emailNotification";


		Components.getComponentPrototype().extend(emailNotification);

		emailNotification._modals = emailNotification._getService("modals");
		emailNotification._helpers = emailNotification._getService("helpers");

		emailNotification.selectedUnitId = null;

		emailNotification.elements = {
			get emailNotificationModal() {
				$('#preSuccMsg').addClass('dis-none');
				return $("[pc-container='email-notification--modal']");
			},
			get preferences() {
				return $("[pc-container='email-notification--preferences']");
			},
			get saveBtn() {
				return $("[pc-container='email-notification--save-btn']");
			},
			get resetBtn() {
				return $("[pc-container='email-notification--reset-btn']");
			},
			get preferencesForm() {
				return $("[pc-container='email-notification--preferences-form']");
			},
			get unitIdInput() {
				return $("[pc-container='email-notification--unit-id-input']");
			},
		};

		emailNotification.bindings = function () {
			emailNotification.elements.emailNotificationModal.on("submit", "[pc-container='email-notification--b2bUnit-form']", function () {
				emailNotification.handlers.onSelectB2bUnit(this);
				return false;
			});
			emailNotification.elements.emailNotificationModal.on("click", "[pc-container='email-notification--save-btn']", function () {
				emailNotification.handlers.onSavePreferences(this);
			});

			emailNotification.elements.emailNotificationModal.on("click", "[pc-container='email-notification--reset-btn']", function () {
				emailNotification.handlers.onResetPreferences(this);
			});
			emailNotification.elements.emailNotificationModal.on("click", "[pc-container='email-notification--cancel-btn']", function () {
				emailNotification.handlers.onCancelClick();
			});
		};

		emailNotification.resetView = function () {
			emailNotification.selectedUnitId = null;
			emailNotification.elements.preferences.empty();
			emailNotification.elements.saveBtn.prop('disabled', true);
			emailNotification.elements.resetBtn.prop('disabled', true);
		};

		emailNotification.handlers = {
			onResetPreferences: function () {
				emailNotification._renderTemplate("preferences", null, true);
				emailNotification._applyScript.base.iCheck();
			},
			onSelectB2bUnit: function (form) {

				var hasErrors = emailNotification._helpers.checkFormForErrors(form);
				if (hasErrors) {
					emailNotification._modals.error.show(emailNotification._messages.formError);
					return;
				}

				var formData = emailNotification._utils.getFormData(form);

				emailNotification.selectedUnitId = formData.unitId;

				emailNotification._api.emailNotification.validateUnit(formData.unitId).then(function (res) {
					if (res && res.status == 200) {
						var validUnitId = res.body;
						emailNotification._api.emailNotification.getPreferences(validUnitId).then(function (res) {
							if (res && res.status == 200) {
								emailNotification.elements.unitIdInput.val(validUnitId);

								emailNotification.context.preferences = res.body;

								emailNotification._renderTemplate("preferences");
								emailNotification._applyScript.base.iCheck();

								emailNotification.elements.saveBtn.prop('disabled', false);
								emailNotification.elements.resetBtn.prop('disabled', false);

							} else {
								emailNotification.resetView();
								console.log(res.message);
							}
						});
					} else {
						emailNotification._modals.error.show(emailNotification._messages.unit.unitIsInvalid);
						emailNotification.resetView();
					}
				});
			},
			onSavePreferences: function () {

				var form = emailNotification.elements.preferencesForm.get(0);

				var hasErrors = emailNotification._helpers.checkFormForErrors(form);
				if (hasErrors) {
					emailNotification._modals.error.show(emailNotification._messages.formError);
					return;
				}

				var formData = emailNotification._utils.getFormData(form);

				var selectedPreference = emailNotification._utils.getFormCheckedValues(form);

				var dataToSend = {
					selectedPreference: selectedPreference.toString(),
					b2bUnitId: emailNotification.selectedUnitId,
					notificationEmail: formData.notificationEmail
				};

				emailNotification._api.emailNotification.savePreferences(dataToSend).then(function (res) {
					if (res && res.status == 200) {
						emailNotification.context.preferences = res.body;
						$('#preSuccMsg').removeClass('dis-none');
						$('#preSuccMsg').addClass('dis-block');
						//emailNotification._modals.success.show(emailNotification._messages.emailNotification.preferencesSaved);
					} else if (res.message) {
						emailNotification._modals.error.show(res.message);
					} else {
						emailNotification._modals.error.show(emailNotification._messages.serverError);
					}
				});
			},
			onCancelClick: function () {
				emailNotification.resetView();
				emailNotification.elements.emailNotificationModal.modal("hide");
			}
		};

		emailNotification.init = function () {
			emailNotification._bindings();
			// emailNotification._events.registerHandler("pageDataInitialized", emailNotification.name, emailNotification.handlers.onPageDataInitialized);
		};

		return emailNotification;


	};

	window.appComponents = appComponents;

})(window.appComponents || {});